<footer class="footer" role="contentinfo">
  <p>&copy; Christians United for Israel</p>
</footer>
